import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import AppContainer from './AppContainer';
import Error from './Error';

import AuthenticatedRoute from './AuthenticatedRoute';
import ManageGuides from './ManageGuides';
import ManageApplicants from './ManageApplicants';
import ManageArchetypes from './ManageArchitypes';
import ManagePayouts from './ManagePayouts';

import { setLanguage } from './utils';
import { LanguageProvider } from './LanguageContext';
import { PopProvider } from './PopupContext';


const BogglerAdminDashboard = lazy(() => import('./BogglerAdminDashboard'));
const BogglerAdmin = lazy(() => import('./BogglerAdmin'));

const root = ReactDOM.createRoot(document.getElementById('root'));

// Helper to get query param
function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

let preferredLanguage = getQueryParam("lang") || 
    localStorage.getItem("buckish-language") || 
    (navigator.language.startsWith("si") ? "sinhala" : "english")


if (preferredLanguage === "sinhala") {
  document.documentElement.lang = "si";
}

//Temporarily set the language for the session to english 

setLanguage("english");

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={
          <div style={{ textAlign: 'center', marginTop: '50px', height: "100vh", width: "100vw" }}>
            <div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
              <img style={{width: "75%", height: "auto"}} src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp" alt="Boggler Logo" />
            </div>
          </div>}>
          
        <div className="ocean">
          <div className="wave"></div>
          <div className="wave wave2"></div>
        </div>
          <PopProvider>
            <Routes>
              <Route element={<AppContainer />}>
                
                <Route index element={<BogglerAdmin />} />

                <Route
                  path="/dashboard"
                  element={<AuthenticatedRoute><BogglerAdminDashboard /></AuthenticatedRoute>}
                />

                <Route
                  path="/applicants"
                  element={<AuthenticatedRoute><ManageApplicants /></AuthenticatedRoute>}
                />

                <Route
                  path="/archetypes"
                  element={<AuthenticatedRoute><ManageArchetypes /></AuthenticatedRoute>}
                />

                <Route
                  path="/guides"
                  element={<AuthenticatedRoute><ManageGuides /></AuthenticatedRoute>}
                />

                <Route
                  path="/payouts"
                  element={<AuthenticatedRoute><ManagePayouts /></AuthenticatedRoute>}
                />
                
                <Route
                  path="*"
                  element={<Error />}
                />
              </Route>
            </Routes>
          </PopProvider>
        </Suspense>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);
